import React, { useEffect, useState } from 'react'
import Cookies from 'js-cookie'
import Header from '../directives/header';
import Footer from '../directives/footer';
import Rightnav from '../directives/rightSidebar';
import Leftnav from '../directives/leftSidebar';
import toast, { Toaster } from 'react-hot-toast';
import banner from '../Assets/BC-newLogos.jpg'
import config from '../coreFIles/config';
import { UpgradeAccountAction, createVipUpgradePaymentIntentAction, getMemberProfilesAction, getglobalSettingsListAction } from '../Action/action';

const getLoginData = () => {
	try {
		const cookieData = Cookies.get('loginSuccessMember');
		return cookieData ? JSON.parse(cookieData) : [];
	} catch (error) {
		console.error('Error parsing loginSuccessMember cookie:', error);
		return [];
	}
};

const loginData = getLoginData();

const VipmemberShip = () => {
	// Style state for reactive styling
	const [Style, setStyle] = useState([]);
	
	useEffect(() => {
		const updateStyles = () => {
			const storedStyle = Cookies.get('domainstyle');
			if (storedStyle) {
				try {
					setStyle(JSON.parse(storedStyle));
				} catch (error) {
					console.error('Error parsing style cookie:', error);
					setStyle([]);
				}
			} else {
				setStyle([]);
			}
		};
		
		updateStyles();
		const interval = setInterval(updateStyles, 500);
		return () => clearInterval(interval);
	}, []);
	
	// Style values
	const getStyleValue = (key) => {
		if (Style && Array.isArray(Style) && Style.length > 0 && Style[0] && Style[0][key]) {
			return `#${Style[0][key]}`;
		}
		return '';
	};
	const timeColor = getStyleValue('time_color');
	const headerButtonColor = getStyleValue('header_buttoncolor');
	const headerMenuColor = getStyleValue('header_menu');
	const headerMenuHoverColor = getStyleValue('header_menu_hover');
	const header_search_text = getStyleValue('header_search_text');
	
    const [vipMembershipFee, setVipMembershipFee] = useState(0);
    const [memberProfile, setMemberProfile] = useState(null);
    const [isVIP, setIsVIP] = useState(false);
    const [stripe, setStripe] = useState(null);
    const [cardElement, setCardElement] = useState(null);
    const [paymentProcessing, setPaymentProcessing] = useState(false);
    const [isCardComplete, setIsCardComplete] = useState(false);

    // style end
    useEffect(() => {
        getSettings();
        loadStripe();
        if (loginData && loginData.id) {
            getMemberProfile();
        }
    }, [])

    // Load Stripe.js
    const loadStripe = () => {
        if (window.Stripe) {
            setStripe(window.Stripe(config.stripePublishableKey));
        } else {
            const script = document.createElement('script');
            script.src = 'https://js.stripe.com/v3/';
            script.async = true;
            script.onload = () => {
                setStripe(window.Stripe(config.stripePublishableKey));
            };
            document.body.appendChild(script);
        }
    }

    // Initialize Stripe Elements when stripe is loaded
    useEffect(() => {
        if (stripe && loginData && loginData.id && !isVIP) {
            // Small delay to ensure DOM is ready
            const initCardElement = () => {
                const cardElementDiv = document.getElementById('vip-page-card-element');
                if (!cardElementDiv) {
                    // Retry if element not found
                    setTimeout(initCardElement, 100);
                    return;
                }

                // Check if card is already mounted
                if (cardElementDiv.querySelector('.StripeElement')) {
                    return;
                }

                const elements = stripe.elements();
                const card = elements.create('card', {
                    style: {
                        base: {
                            fontSize: '16px',
                            color: '#424770',
                            '::placeholder': {
                                color: '#aab7c4',
                            },
                        },
                        invalid: {
                            color: '#9e2146',
                        },
                    },
                });
                
                card.mount('#vip-page-card-element');
                setCardElement(card);

                card.on('change', ({error, complete}) => {
                    const displayError = document.getElementById('vip-page-card-errors');
                    if (displayError) {
                        if (error) {
                            displayError.textContent = error.message;
                            setIsCardComplete(false);
                        } else {
                            displayError.textContent = '';
                            setIsCardComplete(complete || false);
                        }
                    } else {
                        setIsCardComplete(complete || false);
                    }
                });
            };

            // Initialize with small delay
            setTimeout(initCardElement, 200);

            return () => {
                const cardElementDiv = document.getElementById('vip-page-card-element');
                if (cardElementDiv) {
                    const stripeElement = cardElementDiv.querySelector('.StripeElement');
                    if (stripeElement) {
                        // Card will be unmounted by Stripe when element is removed
                    }
                }
            };
        }
    }, [stripe, loginData, isVIP])

    const getSettings = async () => {
        let res = await getglobalSettingsListAction({ domain_id: 0 });
        if (res.success) {
            setVipMembershipFee(res.data.vip_membership_fee || 0);
        }
    }

    const getMemberProfile = async () => {
        try {
            let res = await getMemberProfilesAction({
                id: loginData?.id,
                email: loginData?.email,
            });
            if (res.success && res.data) {
                setMemberProfile(res.data);
                setIsVIP(res.data.isVIP || false);
            }
        } catch (error) {
            console.error('Error fetching member profile:', error);
        }
    }




    // image click base url
    const imgclick = () => {
        window.location.href = `${config.baseUrl}`;
    }

    //    button submit - redirect to login if not logged in
    const handlesubmit = () => {
        if (!loginData || !loginData.id) {
            toast.error("Please login first to upgrade");
            setTimeout(() => {
                window.location.href = `${config.baseUrl}login`
            }, 1000)
        }
    }

    const processVipUpgrade = async () => {
        try {
            if (!loginData || !loginData.id) {
                toast.error("Please login first");
                return;
            }

            if (isVIP) {
                toast.success("You are already a VIP member!");
                return;
            }

            setPaymentProcessing(true);

            // Step 1: Create payment intent
            const paymentIntentRes = await createVipUpgradePaymentIntentAction({ 
                member_id: loginData?.id,
                email: loginData?.email 
            });
            
            if (!paymentIntentRes.success) {
                toast.error(paymentIntentRes.msg || "Failed to initialize payment");
                setPaymentProcessing(false);
                return;
            }

            // Step 2: Confirm payment with Stripe
            if (!stripe || !cardElement) {
                toast.error("Payment system not ready. Please refresh the page.");
                setPaymentProcessing(false);
                return;
            }

            const { error: stripeError, paymentIntent: confirmedPaymentIntent } = await stripe.confirmCardPayment(
                paymentIntentRes.client_secret,
                {
                    payment_method: {
                        card: cardElement,
                        billing_details: {
                            name: `${memberProfile?.profile?.fname || ''} ${memberProfile?.profile?.lname || ''}`.trim() || loginData?.email,
                            email: loginData?.email,
                        },
                    },
                }
            );

            if (stripeError) {
                toast.error(stripeError.message || "Payment failed");
                setPaymentProcessing(false);
                return;
            }

            if (confirmedPaymentIntent.status === 'succeeded') {
                // Step 3: Upgrade account with payment intent ID
                const upgradeRes = await UpgradeAccountAction({
                    member_id: loginData?.id,
                    payment_intent_id: confirmedPaymentIntent.id
                });
                
                if (upgradeRes.success) {
                    toast.success(upgradeRes.msg);
                    setTimeout(() => {
                        window.location.reload();
                    }, 2000);
                } else {
                    toast.error(upgradeRes.msg || "Upgrade failed");
                    setPaymentProcessing(false);
                }
            } else {
                toast.error("Payment not completed");
                setPaymentProcessing(false);
            }
        } catch (error) {
            console.error('Payment Error:', error);
            toast.error("An error occurred during payment. Please try again.");
            setPaymentProcessing(false);
        }
    }
    return (
        <>

            <Header />

            <div className="add-section mb-3">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3">
                            <Leftnav />
                        </div>

                        <div className="col-lg-6">

                            {!document.cookie.includes("loginSuccessMember") ?
                                <div className="classification-section">
                                    <h2 className="page-heading" style={{ background: headerMenuColor }}>VIP Membership</h2>

                                    <div className="table-responsive table-striped">
                                        <p>Become a VIP Member for 12 months and you can post as many ads as you like with no restrictions*<u><b>( Excluding 'Personals' section )</b></u> on all our websites with the same login:</p>
                                    </div>
                                    <div className='img'>
                                        <div className='col-lg-12'>
                                            <img id='bannervip' style={{ width: "600px", margin: "10px" }} src={banner} alt='internet error' onClick={imgclick} />
                                        </div>
                                    </div>
                                    <div className="table-responsive table-striped">For only ${vipMembershipFee || 0} VIP memberships will assist in helping our network grow , fund new features on the website and you will get priority notification of any coupon deals, special promotions and event invites.

                                        Upgrade today and post as many ads as you like to thousands of weekly visitors!!!
                                        * This offer is not available to advertisers in the 'Personals' section- Please contact us for VIP advertising in this section.
                                    </div>


                                </div>
                                : (
                                    <div className="classification-section">
                                        <h2 className="page-heading" style={{ background: headerMenuColor }}>VIP Membership</h2>
                                        
                                        {isVIP ? (
                                            <div className="alert alert-success">
                                                <h4>Congratulations! You are already a VIP Member</h4>
                                                {memberProfile?.daysLeft > 0 && (
                                                    <p>Your VIP membership is valid for {memberProfile.daysLeft} more days.</p>
                                                )}
                                            </div>
                                        ) : (
                                            <>
                                                <div className="table-responsive table-striped">
                                                    <p>Become a VIP Member for 12 months and you can post as many ads as you like with no restrictions*<u><b>( Excluding 'Personals' section )</b></u> on all our websites with the same login:</p>
                                                </div>
                                                <div className='img'>
                                                    <div className='col-lg-12'>
                                                        <img id='bannervip' style={{ width: "600px", margin: "10px" }} src={banner} alt='internet error' onClick={imgclick} />
                                                    </div>
                                                </div>
                                                <div className="table-responsive table-striped">
                                                    <p><strong>VIP Membership Fee: ${vipMembershipFee || 0}</strong></p>
                                                    <p>Upgrade today and post as many ads as you like to thousands of weekly visitors!!!</p>
                                                    <p>* This offer is not available to advertisers in the 'Personals' section- Please contact us for VIP advertising in this section.</p>
                                                </div>

                                                <div className="bondiclassified-fromsection mt-4">
                                                    <h2 className="page-heading">Payment Details</h2>
                                                    <div className="catagoryfrom">
                                                        <div className="row">
                                                            <div className="col-md-12 col-sm-12">
                                                                <div className="form-group">
                                                                    <label htmlFor="vip-page-card-element">Card Details <span className='text-danger'>*</span></label>
                                                                    <div id="vip-page-card-element" style={{ padding: '10px', border: '1px solid #ccc', borderRadius: '4px', backgroundColor: '#fff' }}>
                                                                        {/* Stripe Card Element will be mounted here */}
                                                                    </div>
                                                                    <div id="vip-page-card-errors" role="alert" style={{ color: '#dc3545', marginTop: '5px' }}></div>
                                                                    <p className="mt-2" style={{ fontSize: '12px', color: '#666' }}>
                                                                        VIP Membership Fee: ${vipMembershipFee || 0} will be charged to your card.
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                )}
                            {!document.cookie.includes("loginSuccessMember") ? (
                                <div className='payVip'>
                                    <a className="payNow" id='pay-now' onClick={handlesubmit} style={{ background: headerButtonColor }} >Pay Now</a>
                                </div>
                            ) : (
                                !isVIP && (
                                    <div className='payVip'>
                                        <button 
                                            className="payNow" 
                                            id='pay-now' 
                                            onClick={processVipUpgrade} 
                                            disabled={paymentProcessing || !isCardComplete}
                                            style={{ 
                                                background: headerButtonColor, 
                                                border: 'none', 
                                                padding: '10px 20px', 
                                                color: 'white', 
                                                borderRadius: '4px', 
                                                cursor: (paymentProcessing || !isCardComplete) ? 'not-allowed' : 'pointer',
                                                opacity: (paymentProcessing || !isCardComplete) ? 0.6 : 1
                                            }}
                                        >
                                            {paymentProcessing ? (
                                                <>Processing... <i className="fa fa-spinner fa-spin"></i></>
                                            ) : (
                                                <>Pay ${vipMembershipFee || 0} & Upgrade to VIP</>
                                            )}
                                        </button>
                                    </div>
                                )
                            )}
                        </div>

                        <div className="col-lg-3">
                            <Rightnav />
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}
export default VipmemberShip;